import React from "react";

const TrackingHistoryComponentLoadable = React.lazy(() =>
  import("./TrackingHistoryComponent")
);

export { TrackingHistoryComponentLoadable };